export const SET_DESIGNER_OPTION_REF = 'SET_DESIGNER_OPTION_REF';
export const SET_DESIGNER_MOBILE_PRODUCTLIST_OPEN = 'SET_DESIGNER_MOBILE_PRODUCTLIST_OPEN';
export const SET_DESIGNER_MOBILE_MODAL_CONTENT = 'SET_DESIGNER_MOBILE_MODAL_CONTENT';

export const setDesignerMobileProductListOpen = (value) => ({
  type: SET_DESIGNER_MOBILE_PRODUCTLIST_OPEN,
  value,
});

export const setDesignerOptionRef = (identifier, value) => ({
  type: SET_DESIGNER_OPTION_REF,
  identifier,
  value,
});

export const setDesignerMobileModalContent = (value) => ({
  type: SET_DESIGNER_MOBILE_MODAL_CONTENT,
  value,
});
